import styled from "styled-components";

export const SProjectLimitModalCloseIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
